

















import Vue from "vue";

// Vuex
import { mapMutations } from "vuex";
import { ADD_ALERT } from "../../store/modules/AlertModule/mutations";

// Vue components
import DeleteInstallationsConfirmationModal from "@/views/App/Tools/LicensesManagement/DeleteInstallationsConfirmationModal.vue";

// Model
import { AlertModel, AlertModelType } from "../../store/modules/AlertModule/types";
import { AuthActionTypeEnum } from "@/model/data/authActions/AuthActionTypeEnum";
import { AuthActionResponseContainer } from "@/model/data/authActions/AuthActionResponseContainer";
import { UploadAuthActionCommand } from "@/model/communication/authActions/UploadAuthActionCommand";
import { DeleteInstallationsResData } from "@/model/communication/authActions/DeleteInstallationsResData";
import { AuthAction } from "@/model/data/authActions/AuthAction";
import { CReqExecutionResultEnum } from "@/model/communication/CReqExecutionResultEnum";

export default Vue.extend({
    components: {
        DeleteInstallationsConfirmationModal,
    },
    data() {
        return {
            AuthActionTypeEnum,
            action: null,
            loading: false,
            executing: false,
        };
    },
    props: ["file"],
    watch: {
        file(newFile) {
            // console.log("GenericConfirmationModal.vue watch() file: ", newFile);
            if (newFile) this.loadFile(newFile);
        },
    },
    methods: {
        ...mapMutations([ADD_ALERT]),

        async onConfirm() {
            if (!this.executing) {
                console.debug("Send this auth action:", this.action);
                try {
                    this.executing = true;
                    const res = await new UploadAuthActionCommand([this.file]).execute();
                    console.debug("UploadAuthActionCommand() res", res);
                    this.executing = false;
                    this.$emit("close");

                    if (res.status == 200 && res.data.Response == 0) {
                        switch ((this.action as AuthAction).type) {
                            case AuthActionTypeEnum.DeleteInstallations:
                                var parsedRes: DeleteInstallationsResData = new DeleteInstallationsResData(res);
                                console.debug("res is a DeleteInstallationsResData:", parsedRes);
                                if (parsedRes.notDeletedInstallationNames.length == 0) {
                                    // everything fine
                                    this[ADD_ALERT](
                                        new AlertModel(AlertModelType.Success, this.$t("authActions.deleteInstallationsOk") + ": " + parsedRes.deletedInstallationNames.join(", "))
                                    );
                                    this.$emit("action-execution-ok");
                                } else {
                                    // something went wrong
                                    if (parsedRes.deletedInstallationNames.length > 0) {
                                        this[ADD_ALERT](
                                            new AlertModel(
                                                AlertModelType.Warning,
                                                this.$t("authActions.deleteInstallationsOk") + ": " + parsedRes.deletedInstallationNames.join(", ")
                                            )
                                        );
                                        this[ADD_ALERT](
                                            new AlertModel(
                                                AlertModelType.Warning,
                                                this.$t("authActions.deleteInstallationsError") + ": " + parsedRes.notDeletedInstallationNames.join(", ")
                                            )
                                        );
                                    } else {
                                        this[ADD_ALERT](
                                            new AlertModel(
                                                AlertModelType.Error,
                                                this.$t("authActions.deleteInstallationsError") + ": " + parsedRes.notDeletedInstallationNames.join(", ")
                                            )
                                        );
                                    }
                                    this.$emit("action-execution-ok");
                                }
                                break;

                            default:
                                break;
                        }
                    } else {
                        console.error("Error: ", res.data.Message);
                        if (res.data.Message != null) {
                            switch (res.data.Message as CReqExecutionResultEnum) {
                                case CReqExecutionResultEnum.SignatureNotValid:
                                    this[ADD_ALERT](new AlertModel(AlertModelType.Error, this.$t("authActions.signatureNotValid")));
                                    break;
                                default:
                                    break;
                            }
                        }
                        this.$emit("action-execution-error");
                    }
                } catch (e) {
                    console.error("Something went wrong during UploadAuthActionCommand execution");
                    this.$emit("action-execution-error");
                    this.executing = false;
                }
            }
        },

        async loadFile(file) {
            if (file) {
                console.debug("GenericConfirmationModal.vue loadFile() - Parse .aares file started");
                try {
                    this.loading = true;
                    var actionContainer = await AuthActionResponseContainer.parseFromFile(file);
                    console.log("GenericConfirmationModal.vue loadFile() - Parsed .aares file: ", actionContainer);
                    if (actionContainer) {
                        this.action = actionContainer.response;
                    }
                    this.loading = false;
                } catch (e) {
                    console.error("Something went wrong deserializing .aares file. Exception: ", e);
                    this.loading = false;
                }
            }
        },
    },
    mounted() {
        this.loadFile(this.file);
    },
});
